import { render, staticRenderFns } from "./AuthoriseLabour.vue?vue&type=template&id=bd7e887a&scoped=true"
import script from "./AuthoriseLabour.vue?vue&type=script&lang=js"
export * from "./AuthoriseLabour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e887a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd7e887a')) {
      api.createRecord('bd7e887a', component.options)
    } else {
      api.reload('bd7e887a', component.options)
    }
    module.hot.accept("./AuthoriseLabour.vue?vue&type=template&id=bd7e887a&scoped=true", function () {
      api.rerender('bd7e887a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseLabour.vue"
export default component.exports